import {combineLatest, merge} from 'rxjs';
import {map, filter} from 'rxjs/operators';
import {aopMsgAll$, aopMsgV2All$} from '@/raw/aop-all';
import {convertOrder} from './orders-contract';
import {contractAirdropPosSubUserIds$} from '@/raw/users';

export const ordersAll$ = aopMsgAll$.pipe(
  filter((o) => !!o.data.orders),
  map((o) => ({
    userId: o.userId,
    data: convertOrder(o.data),
  }))
);

export const contractOrders$ = combineLatest([aopMsgAll$, contractAirdropPosSubUserIds$]).pipe(
  filter(([o, userIds]) => !!o.data.orders && isAirdropPosUserMsg(o.data, userIds)),
  map(([o]) => o)
);
export const snapshotOrders$ = contractOrders$.pipe(
  filter((o) => o.data.type === 'snapshot'),
  map((o) => o.data)
);
export const incrementalOrders$ = contractOrders$.pipe(
  filter((o) => o.data.type === 'incremental'),
  map((o) => o.data)
);

export const contractOrdersV2$ = combineLatest([aopMsgV2All$, contractAirdropPosSubUserIds$]).pipe(
  filter(([o, userIds]) => !!o.data.orders && isAirdropPosUserMsg(o.data, userIds)),
  map(([o]) => o)
);
export const snapshotOrdersV2$ = contractOrdersV2$.pipe(
  filter((o) => o.data.type === 'snapshot'),
  map((o) => convertOrder(o.data))
);
export const incrementalOrdersV2$ = contractOrdersV2$.pipe(
  filter((o) => o.data.type === 'incremental'),
  map((o) => convertOrder(o.data))
);

export const contractSnapshotOrders$ = merge(snapshotOrders$, snapshotOrdersV2$);
export const contractIncrementalOrders$ = merge(incrementalOrders$, incrementalOrdersV2$);

export function isAirdropPosUserMsg(o, userIds: number[]) {
  if (o.hasOwnProperty('accounts_p1')) {
    return !![o.accounts_p1, o.positions_p1].find((items) => items && items[0] && userIds.includes(items[0].userID));
  }
  return !![o.accounts, o.positions].find((items) => items && items[0] && userIds.includes(items[0].userID));
}
